import TextWidget from './TextWidget';

export default TextWidget;
